import script from "./BivariateUI.vue?vue&type=script&setup=true&lang=js"
export * from "./BivariateUI.vue?vue&type=script&setup=true&lang=js"

import "./BivariateUI.vue?vue&type=style&index=0&id=7b5a0440&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b5a0440"]])

export default __exports__